import proxy from '@/services/ProxyService';
import useAppStore from '@/store/app';
import { Box } from '@mui/system';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export default function Proxy() {
  const { search } = useLocation();
  const { interfaces } = useAppStore();

  const { entityType, entityId, method, ...rest } = Object.fromEntries(
    new URLSearchParams(search),
  );

  const [pdfUrl, setPdfUrl] = useState(null);

  useEffect(() => {
    const fetchPdf = async () => {
      if (!interfaces) {
        console.error('Interfaces not loaded');
        return;
      }

      const iface = interfaces[rest.interface];

      if (!iface) {
        console.error('Interface not found');
        return;
      }

      const res = await proxy.get(
        `/${iface}/${entityType}/id/${entityId}/${method}`,
        { responseType: 'arraybuffer' },
      );

      const base64Pdf = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result.split(',')[1]);
        reader.readAsDataURL(new Blob([res.data], { type: 'application/pdf' }));
      });

      const pdfDataUrl = `data:application/pdf;base64,${base64Pdf}`;
      setPdfUrl(pdfDataUrl);
    };

    fetchPdf();
  }, [interfaces, entityType, entityId, method]);

  return (
    <Box sx={{ height: '100%' }}>
      {pdfUrl ? (
        <iframe
          src={pdfUrl}
          title="PDF Viewer"
          style={{
            width: '100%',
            height: '100%',
            display: 'block',
            border: 'none',
          }}
        ></iframe>
      ) : (
        <p>Loading PDF...</p>
      )}
    </Box>
  );
}
